import step1 from 'static/img/home/howItWorks/step1.svg';
import step2 from 'static/img/home/howItWorks/step2.svg';
import step3 from 'static/img/home/howItWorks/step3.svg';

interface IHowItWorkStep {
  icon: string;
  title: string;
}

export const howItWorksSteps: IHowItWorkStep[] = [{
  icon: step1,
  title: 'Find your perfect online tutor',
},
{
  icon: step2,
  title: 'Start with a FREE online trial lesson',
},
{
  icon: step3,
  title: 'Become a Member and save',
}];
